import { InformationIcon } from 'assets/icons';
import Chip from 'components/chip/chip';
import Tooltip from 'components/tooltips/Tooltips';
import { useEffect } from 'react';
import ApiDataBase from 'server';

const SalarySection = ({
  smic,
  salary,
  setSmic,
  setSalary,
  setDataCreateMission,
}) => {
  const handleSelect = () => {
    setSalary(smic);
    setDataCreateMission((prev) => ({ ...prev, salary: smic }));
  };

  const handleSalaryChange = (input) => {
    setSalary(input);
    setDataCreateMission((prev) => ({ ...prev, salary: input }));
  };

  useEffect(() => {
    ApiDataBase.getMinimumWage(
      (data) => {
        if (data?.hourly?.gross) {
          setSmic((prev) => prev || data.hourly.gross);
          setSalary((prev) => prev || data.hourly.gross);
          setDataCreateMission((prev) => ({
            ...prev,
            salary: prev.salary || data.hourly.gross,
          }));
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }, [setDataCreateMission, setSalary, setSmic]);

  return (
    <div className="flex flex-col gap-4">
      <div className="ft-xl">Rémunération de l'intérimaire</div>
      <div className="relative">
        <input
          name="salary"
          value={salary}
          onChange={(e) => {
            const input = e.target.value
              .replace(/,/g, '.')
              .replace(/[^0-9.]/g, '');
            handleSalaryChange(input);
          }}
          inputMode="decimal"
          className="w-full h-10 pl-10 pr-3 ft-b placeholder-gray-600 border rounded-lg"
          type="text"
        />
        <div className="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none">
          h/€
        </div>
        <Tooltip
          text={
            'La rémunération comprend le salaire ou traitement de base et tous les autres avantages et accessoires payés directement ou indirectement, en espèces ou en nature.'
          }
          placement="bottom"
        >
          <div className="absolute inset-y-0 right-0 z-20 flex items-center px-2 cursor-pointer">
            <InformationIcon color={'#2CAFFF'} wh={15} />
          </div>
        </Tooltip>
      </div>
      <div className="w-44">
        <Chip
          select={salary === smic}
          type={salary === smic ? 'SELECTON' : 'SELECTOFF'}
          onClick={handleSelect}
        >
          SMIC : {smic}€/h
        </Chip>
      </div>
    </div>
  );
};

export default SalarySection;
